"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var variantMapp = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
};
var Typography = function (_a) {
    var classes = _a.classes, _b = _a.align, align = _b === void 0 ? 'inherit' : _b, _c = _a.children, children = _c === void 0 ? null : _c, _d = _a.color, color = _d === void 0 ? 'initial' : _d, _e = _a.display, display = _e === void 0 ? 'block' : _e, _f = _a.gutterBottom, gutterBottom = _f === void 0 ? false : _f, _g = _a.noWrap, noWrap = _g === void 0 ? false : _g, _h = _a.paragraph, paragraph = _h === void 0 ? false : _h, _j = _a.variant, variant = _j === void 0 ? 'body1' : _j, _k = _a.variantMapping, variantMapping = _k === void 0 ? variantMapp : _k, component = _a.component;
    return (react_1.default.createElement(Typography_1.default, __assign({ classes: classes, align: align, color: color, display: display, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, variantMapping: variantMapping }, component ? { component: component } : {}), children));
};
exports.default = Typography;
